import { RouteObject } from "react-router-dom";
import AnnouncementListPage from "@/pages/announcements/AnnouncementListPage";
import AnnouncementDetailPage from "@/pages/announcements/AnnouncementDetailPage";
import ErrorBoundary from "@/components/layout/ErrorBoundary";

export const announcementRoutes: RouteObject[] = [
  {
    path: "/announcements",
    children: [
      {
        index: true,
        element: <AnnouncementListPage />,
        errorElement: <ErrorBoundary />
      },
      {
        path: ":id",
        element: <AnnouncementDetailPage />,
        errorElement: <ErrorBoundary />
      }
    ]
  }
];
